// extracted by mini-css-extract-plugin
export default {"task-page":"TaskPage_task-page__b2V-x","task-page-body":"TaskPage_task-page-body__oIbbv","center":"TaskPage_center__k6mn4"};